import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  NotificationRef,
  NotificationService,
} from '@progress/kendo-angular-notification';
import { NgClass } from '@angular/common';

@Component({
  selector: 'maximizer-notification',
  template: `<ng-template #template>
    <div class="flex items-center">
      @if (icon) {
        <span
          class="mr-2 fa-icons icon-solid icon-18"
          [ngClass]="'icon-' + icon"
        ></span>
      }
      <span>
        <ng-content></ng-content>
      </span>
    </div>
  </ng-template>`,
  imports: [NgClass],
})
export class NotificationComponent {
  @Input()
  icon?: string;

  @Input()
  type: 'none' | 'success' | 'warning' | 'error' | 'info' = 'none';

  @Input()
  horizontal: 'left' | 'center' | 'right' = 'center';

  @Input()
  vertical: 'top' | 'bottom' = 'bottom';

  @Input()
  animation?: 'slide' | 'fade';

  @Input()
  hideAfter = 2000;

  @Input()
  closable?: boolean;

  @Input()
  appendTo?: ViewContainerRef;

  @ViewChild('template', { read: TemplateRef })
  template: TemplateRef<unknown> | string | undefined;

  notification?: NotificationRef | null;

  constructor(private readonly service: NotificationService) {}

  show(): NotificationRef | null {
    if (this.template) {
      this.notification = this.service.show({
        content: this.template,
        hideAfter: this.hideAfter,
        appendTo: this.appendTo,
        animation: { type: this.animation, duration: 500 },
        position: { horizontal: this.horizontal, vertical: this.vertical },
        type: { style: this.type, icon: false },
        closable: this.closable,
      });
      this.hideClosableNotificationAfter();
      return this.notification;
    }
    return null;
  }

  private hideClosableNotificationAfter() {
    if (!this.closable || this.hideAfter <= 0) return;
    setTimeout(() => {
      if (this.notification) {
        this.notification.hide();
      }
    }, this.hideAfter);
  }
}
